import {useI18n} from 'i18n/I18nContext'
import {EventAddons} from 'organization/Event/Addons/EventAddons'
import EventPage from 'organization/Event/EventPage'
import {EventFaqHelp} from 'organization/Event/Help/FAQ'
import BreadcrumMenu from 'organization/theme/Breadcrum'
import React from 'react'

export const Addons = () => {
  const {t} = useI18n()
  return (
    <EventPage>
      <>
        <div className="row pl-30 pb-30 pr-30">
          <BreadcrumMenu
            title={t('org.sidebar.addons')}
            helpInfo={<EventFaqHelp faqKey="addonsPage" />}
          />

          <div className="event__venue-area">
            <div className="row">
              <EventAddons />
            </div>
          </div>
        </div>
      </>
    </EventPage>
  )
}
